export default {
    community_blue_moon: {
        getOne: ['GET', '/read-configuration/{customerUUID}/{communityUUID}/{purpose}'],
    },
};
